import { useState } from "react";
import SelectTab from "./SelectTab";
import BannerLayoutRenderer from "./BannerLayoutList";
import UploadImages from "./UploadImages";

export default function FrameTemplate() {
  const [activeTab, setActiveTab] = useState("template");

  const [banner1Data, setBanner1Data] = useState({ title: "", price: "" });
  const [banner2Data, setBanner2Data] = useState([{ title: "", price: "" }]);
  const [banner3Data, setBanner3Data] = useState({ title: "" });

  const tabs = [
    {
      key: "template",
      label: "템플릿 선택",
      layout: "banner1",
      imageSrc:
        "https://i.pinimg.com/736x/fd/9b/0f/fd9b0fe0661fe4759fdc40c6443a7026.jpg",
    },
    {
      key: "preview",
      label: "배너 미리보기",
      layout: "banner2",
      imageSrc:
        "https://i.pinimg.com/736x/fd/9b/0f/fd9b0fe0661fe4759fdc40c6443a7026.jpg",
    },
    {
      key: "setting",
      label: "설정",
      layout: "banner3",
      imageSrc:
        "https://i.pinimg.com/736x/fd/9b/0f/fd9b0fe0661fe4759fdc40c6443a7026.jpg",
    },
    {
      key: "template1",
      label: "템플릿 선택",
      layout: "banner1",
      imageSrc:
        "https://i.pinimg.com/736x/fd/9b/0f/fd9b0fe0661fe4759fdc40c6443a7026.jpg",
    },
    {
      key: "preview1",
      label: "배너 미리보기",
      layout: "banner2",
      imageSrc:
        "https://i.pinimg.com/736x/fd/9b/0f/fd9b0fe0661fe4759fdc40c6443a7026.jpg",
    },
    {
      key: "setting1",
      label: "설정",
      layout: "banner3",
      imageSrc:
        "https://i.pinimg.com/736x/fd/9b/0f/fd9b0fe0661fe4759fdc40c6443a7026.jpg",
    },
  ];

  const active = tabs.find((tab) => tab.key === activeTab);

  return (
    <div className="max-w-6xl mx-auto pt-4">
      <div className="flex gap-8 bg-white border-gray-200 border w-full rounded-2xl p-4 pb-8">
        <div className="w-1/2">
          <h1 className="text-sm font-bold mb-4 text-gray-500">
            SELECT DESIGN
          </h1>
          <SelectTab
            tabs={tabs}
            activeTab={activeTab}
            onTabChange={setActiveTab}
            direction="vertical"
          />
        </div>
        <div className="w-1/2">
          <h1 className="text-sm font-bold mb-4 text-gray-500">
            UPLOAD IMAGES
          </h1>
          <UploadImages />
        </div>
      </div>
      <div className="my-8 bg-white border-gray-200 border rounded-2xl ">
        <div className="flex">
          <aside className="w-1/2 space-y-4 p-4">
            <h1 className="text-sm font-bold mb-4 text-gray-500">
              DETAIL INFO
            </h1>
            <div className=" min-h-[200px]">
              <BannerLayoutRenderer
                layout={active?.layout}
                showFormOnly
                banner1Data={banner1Data}
                setBanner1Data={setBanner1Data}
                banner2Data={banner2Data}
                setBanner2Data={setBanner2Data}
                banner3Data={banner3Data}
                setBanner3Data={setBanner3Data}
              />
              <div className="flex space-x-4 overflow-x-auto mt-4">
                <button className="px-4 py-2 w-full text-sm font-medium rounded transition bg-blue-500 text-white">
                  Submit
                </button>
              </div>
            </div>
          </aside>
          <main className="flex-1 bg-gray-100 rounded-r-xl p-4">
            <BannerLayoutRenderer
              layout={active?.layout}
              showLayoutOnly
              banner1Data={banner1Data}
              setBanner1Data={setBanner1Data}
              banner2Data={banner2Data}
              setBanner2Data={setBanner2Data}
              banner3Data={banner3Data}
              setBanner3Data={setBanner3Data}
            />
          </main>
        </div>
      </div>
    </div>
  );
}
